/**
 * @module overallResults
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyReportingActions } from '~/behaviors/actions/survey_reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeOverallResult = (state, action) => {
  const overallResults = action.payload?.entities?.overallResults || {};

  return { ...state, ...overallResults };
};

const mergeOverallAttributeResults = (state, action) => {
  const currentOverallResultId = action.payload?.currentOverallResultId;
  const overallAttributeResult = action.payload?.result?.overallAttributeResult;

  if (overallAttributeResult && !state[currentOverallResultId].attributeResults.includes(overallAttributeResult)) {
    state[currentOverallResultId].attributeResults.push(overallAttributeResult);
  }
};

const overallResults = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(surveyReportingActions.fetchReportingResults.fulfilled, mergeOverallResult);

  builder.addCase(surveyReportingActions.fetchReportingAttributeResult.fulfilled, mergeOverallAttributeResults);
});

export default overallResults;
